import {Pagination} from 'ant-design-vue'
import Vue from 'vue'
import httpManager from '../../util/common'
import 'ant-design-vue/dist/antd.css'
import LimitMask from '../../common/components/mask.vue'


Vue.use(Pagination)

let iconPath = '/static/images/event/'

let vm = {
  delimiters: ['{', '}'],
  // props: {
  //   specifyPage: Number//组件通信传递 父组件为-->
  // },
  props:['specifyPage'],
  data: () => {
    return {
      data: [],
      follow_entity: false,
      keyword: null,
      eventtype: null,
      eventnature: "",
      subtype: "",
      impactlevel: "",
      sentiment: null,
      start: null,
      end: null,
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount: 3,
        perfect: true,
      },
      divloading: false,
      is_instruction_show: false,
      showMask: false
    }
  },
  methods: {
    PrefixInteger (num, n) {
      return (Array(n).join(0) + num).slice(-n)
    },
    showEntity (oaid) {
      const {
        href
      } = this.$router.resolve({path: '/entity/' + oaid + '/home'})
      window.open(href, '_blank')
    },
    showSentimentIcon (sentiment) {
      let lan = ''
      if (this.$i18n.locale === 'en'){
        lan = '-en'
      }
      return iconPath + '/sentiment' + sentiment + lan + '.png'
    },
    showImpactLevelIcon (sentiment, impactLevel) {
      let lan = ''
      if (this.$i18n.locale === 'en'){
        lan = '-en'
      }
      let sentiment2color = {'-1': 'red', '0': 'orange', '1': 'green'}
      if (sentiment in sentiment2color) {
        if (impactLevel != null) {
          return iconPath + impactLevel + 'l' + sentiment2color[sentiment] + lan + '.png'
        } else {
          return iconPath + sentiment2color[sentiment] + lan + '.png'
        }
      } else {
        return iconPath + 'orange' + lan + '.png'
      }
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getESGData()
    },
    getESGData () {
      let self = this
      self.divloading = true
      let params = new Map()
      params.set('pagenum', self.page.pagenum)
      params.set('pagesize', self.page.pagesize)
      if(self.eventnature||self.eventnature===0){
        params.set('sentiment', self.eventnature)
      }
      if(self.subtype){
        params.set('sub_type', self.subtype)
      }
      if(self.impactlevel){
        params.set('impact_level', self.impactlevel)
      }
      params.set('follow_entity', self.follow_entity)
      httpManager('esg_event', params)
        .then(response => {
          self.data = response.data.data
          self.page.total = response.data.page.total
          self.divloading = false
        })
        .catch(error => {
          if (this.$route.path === '/home' && error.response.status === 403) {
            this.showMask = true
          }
          console.log(error)
          self.divloading = false
        })
    }

  },
  created() {
    // 初始化页面列表数据条数
    if(this.specifyPage) {
      this.page.pagesize = this.specifyPage
    }
  },
  mounted () {
    // 获取esg数据
    this.getESGData()
  },
  watch: {
    eventnature() {
      this.page.pagenum = 1
      this.getESGData()
    },
    eventtype: function () {
      // this.companyComplete();
      if (!this.closeClick) {
        this.companyComplete()
      } else {
        this.closeClick = false
      }
    },
    impactlevel: function () {
      this.page.pagenum = 1
      this.getESGData()
    },
    subtype: function () {
      this.page.pagenum = 1
      this.getESGData()
    },
    follow_entity: function () {
      this.page.pagenum = 1
      this.getESGData()
    }
  },
  computed: {
    esg_event_type_list() {
      return [
        {'key': this.$t('event.environmental_penalty'),'value':'EnvPunishment'},
        {'key': this.$t('event.environmental_impact_assessment'), 'value': 'EnvImpactAssessment'},
        {'key': this.$t('event.financial_supervision_punishment'),'value':'BankInsurancePunishment'},
        {'key': this.$t('event.work_safety_accident'),'value':'WorkSafetyIncident'},
        {'key': this.$t('event.work_safety_penalty'),'value':'WorkSafetyPunishment'},
        {'key': this.$t('event.product_sampling'), 'value': 'ProductInspection'},
        {'key': this.$t('event.product_recal'),'value':'ProductRecall'},
        {'key': this.$t('event.market_supervision_penalty'), 'value': 'MarketPunishment'},
        {'key': this.$t('event.flight_check'), 'value': 'UnannouncedInspection'},
        {'key': this.$t('event.anticorruption'), 'value': 'AntiCorruption'},
        {'key': this.$t('event.supply_chain'), 'value': 'Announcement'},
        {'key': this.$t('event.security_punishment'), 'value': 'SecurityPunishment'},
        {'key': this.$t('event.security_regulatory'), 'value': 'SecurityRegulatory'},
        {'key': this.$t('event.exchange_regulatory'), 'value': 'ExchangeRegulatory'},
        {'key': this.$t('event.fmi_regulatory'), 'value': 'FinancialMarketInstitutionRegulatory'},
        {'key': this.$t('event.natural_resource_punishment'), 'value': 'NaturalResourcePunishment'},
        {'key': this.$t('event.taxation_punishment'), 'value': 'TaxationPunishment'},
      ]
    },
    esg_event_impact_level_list() {
      return [
        {'key': this.$t('event.level_1'),'value':1},
        {'key': this.$t('event.level_2'),'value':2},
        {'key': this.$t('event.level_3'),'value':3},
        {'key': this.$t('event.level_4'),'value':4},
      ]
    },
    esg_event_nature_list() {
      return [
        {'key': this.$t('event.positive'),'value': 1},
        {'key': this.$t('event.neutral'),'value': 0},
        {'key': this.$t('event.reverse'),'value': -1}
      ]
    }
  }
}
Vue.component('esg-event', vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_event_list.js